import { render, staticRenderFns } from "./DeliveryReceiptsList.vue?vue&type=template&id=2ddadb58&scoped=true&"
import script from "./DeliveryReceiptsList.vue?vue&type=script&lang=js&"
export * from "./DeliveryReceiptsList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryReceiptsList.vue?vue&type=style&index=0&id=2ddadb58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddadb58",
  null
  
)

export default component.exports